import { tw } from '@/utils/tw';
import ScrollArticleLabelTheme from 'base/components/ScrollArticleLabel/theme';

const ScrollArticleLabel = tw.theme({
  extend: ScrollArticleLabelTheme,
  base: `text-body-md before:bg-gray-800 after:bg-gray-800`,
});

export default ScrollArticleLabel;
